import { Injectable } from '@angular/core';

/**
 * SIMR §5.2 — detects unsaved work before role switch.
 * Standard Angular forms (name="form" / "quick_form") plus page-specific workflow checks.
 */
@Injectable({ providedIn: 'root' })
export class SimrUnsavedChangesService {
  private pageChecks = new Map<string, () => boolean>();

  registerPageCheck(pageId: string, check: () => boolean): void {
    this.pageChecks.set(pageId, check);
  }

  unregisterPageCheck(pageId: string): void {
    this.pageChecks.delete(pageId);
  }

  hasUnsavedChanges(): boolean {
    for (const check of this.pageChecks.values()) {
      try {
        if (check()) {
          return true;
        }
      } catch (e) {
        console.warn('[SimrUnsavedChanges] page check error', e);
      }
    }
    return this.hasStandardFormChanges();
  }

  private hasStandardFormChanges(): boolean {
    const editForms = document.querySelectorAll(
      'form.ng-dirty[name="form"], form.ng-dirty[name="quick_form"]'
    );

    for (const form of Array.from(editForms)) {
      const dirtyField = form.querySelector(
        'input.ng-dirty, textarea.ng-dirty, select.ng-dirty, ion-input.ng-dirty, ion-textarea.ng-dirty, ion-select.ng-dirty, ion-checkbox.ng-dirty, ion-radio-group.ion-dirty, .ng-select.ng-dirty'
      );
      if (dirtyField) {
        return true;
      }
    }

    return false;
  }
}
